package app.components

import dev.fritz2.core.*

fun RenderContext.pagination(currentPage: Int, totalPages: Int, onPageChange: (Int) -> Unit) {
    nav {
        ul("inline-flex -space-x-px text-sm cursor-pointer") {
            li {
                a("flex items-center justify-center px-3 h-8 ms-0 leading-tight text-gray-500 dark:text-gray-400 bg-white dark:bg-gray-800 border border-e-0 border-gray-300 dark:border-gray-600 rounded-s-lg hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-gray-700 dark:hover:text-white") {
                    +"Previous"
                    clicks handledBy { if (currentPage > 1) onPageChange(currentPage - 1) }
                }
            }

            val range = when {
                totalPages <= 7 -> 1..totalPages            // If total pages ≤ 7, show all pages
                currentPage <= 4 -> 1..5                    // If near start, show first 5 pages
                currentPage >= totalPages - 3 -> (totalPages - 4)..totalPages  // If near end, show last 5 pages
                else -> (currentPage - 2)..(currentPage + 2) // Otherwise show 2 pages before and after current
            }

            if (range.first > 1) {
                li {
                    a("flex items-center justify-center px-3 h-8 leading-tight text-gray-500 dark:text-gray-400 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-gray-700 dark:hover:text-white") {
                        +"1"
                        clicks handledBy { onPageChange(1) }
                    }
                }
                if (range.first > 2) {
                    li {
                        a("flex items-center justify-center px-3 h-8 leading-tight text-gray-500 dark:text-gray-400 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600") {
                            +"..."
                        }
                    }
                }
            }

            range.forEach { i ->
                li {
                    val isCurrentPage = i == currentPage
                    val baseClasses = "flex items-center justify-center px-3 h-8 leading-tight border border-gray-300 dark:border-gray-600"
                    val activeClasses = if (isCurrentPage) {
                        " text-blue-600 dark:text-blue-500 bg-blue-50 dark:bg-gray-700 hover:bg-blue-100 dark:hover:bg-gray-600"
                    } else {
                        " text-gray-500 dark:text-gray-400 bg-white dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-gray-700 dark:hover:text-white"
                    }

                    a(baseClasses + activeClasses) {
                        if (isCurrentPage) {
                            attr("aria-current", "page")
                        }
                        +"$i"
                        clicks handledBy { onPageChange(i) }
                    }
                }
            }

            if (range.last < totalPages) {
                if (range.last < totalPages - 1) {
                    li {
                        a("flex items-center justify-center px-3 h-8 leading-tight text-gray-500 dark:text-gray-400 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600") {
                            +"..."
                        }
                    }
                }
                li {
                    a("flex items-center justify-center px-3 h-8 leading-tight text-gray-500 dark:text-gray-400 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-gray-700 dark:hover:text-white") {
                        +"$totalPages"
                        clicks handledBy { onPageChange(totalPages) }
                    }
                }
            }

            li {
                a("flex items-center justify-center px-3 h-8 leading-tight text-gray-500 dark:text-gray-400 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-e-lg hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-gray-700 dark:hover:text-white") {
                    +"Next"
                    clicks handledBy { if (currentPage < totalPages) onPageChange(currentPage + 1) }
                }
            }
        }
    }
}
